import { render, staticRenderFns } from "./TeamMain.vue?vue&type=template&id=35ee89f1&scoped=true&"
import script from "./TeamMain.vue?vue&type=script&lang=js&"
export * from "./TeamMain.vue?vue&type=script&lang=js&"
import style0 from "./TeamMain.vue?vue&type=style&index=0&id=35ee89f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee89f1",
  null
  
)

export default component.exports